import { makeStyles } from '@material-ui/core/styles';

const useScoringStyles = makeStyles((theme) => ({
  sectionSpacer: {
    height: 50,
    padding: '10px 0',
  },
  rowSpacer: {
    height: 30,
  },
  textRowSpacer: {
    [theme.breakpoints.up('sm')]: {
      height: 50,
    },
  },
  [theme.breakpoints.down('xs')]: {
    textField: {
      fontSize: '0.75rem',
    },
    root: {
      '& .MuiFormLabel-root': {
        fontSize: '0.75rem',
      },
    },
  },
  printedContent: {
    '@media print': {
      marginBottom: 10,
    },
    '@media screen': {
      display: 'none',
    },
  },
  unprintedContent: {
    '@media print': {
      display: 'none',
    },
    '@media screen': {},
  },
  alignPrintedContent: {
    lineHeight: '25px',
    verticalAlign: 'top',
  },
  rubricTitle: {
    fontSize: '1.05rem',
    fontWeight: 700,
  },
  rubricQuestion: {
    [theme.breakpoints.up('sm')]: {
      height: 50,
    },
    fontSize: '0.90rem',
    fontWeight: 600,
  },
  rubricExplanation: {
    fontSize: '0.90rem',
    fontStyle: 'italic',
    height: 80,
  },
  rubricScore: {
    [theme.breakpoints.up('sm')]: {
      height: 30,
    },
    fontSize: '1.05rem',
    fontWeight: 400,
  },
}));

export default useScoringStyles;
